import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { logEnvironmentConfig, verifyEnvironment } from "./utils/config-debug";
import { initHubSpotTracking } from "./lib/hubspot";
import { initLeadSourceTracking } from "./lib/lead-source";

// Runtime environment verification (development and staging only)
if (import.meta.env.DEV || import.meta.env.VITE_ENVIRONMENT === "development" || import.meta.env.VITE_ENVIRONMENT === "staging") {
  logEnvironmentConfig();

  // Verify we're connected to the correct Supabase backend
  const expectedProjectId =
    import.meta.env.VITE_ENVIRONMENT === "staging" ? "" : "";

  verifyEnvironment(expectedProjectId);
}

// Initialize HubSpot tracking
initHubSpotTracking();

// Initialize lead source tracking (captures UTM parameters, referrer, landing page)
initLeadSourceTracking();

// Development helper: Detect and handle module loading errors
if (import.meta.env.DEV) {
  window.addEventListener('error', (event) => {
    // Check if it's a module loading error
    if (event.error && event.error.message && (
      event.error.message.includes('Failed to fetch') ||
      event.error.message.includes('Loading chunk') ||
      event.error.message.includes('Unexpected token')
    )) {
      console.error('🚨 Module loading error detected. This might be due to cached broken code.');
      console.error('💡 Try: Hard refresh (Cmd+Shift+R / Ctrl+Shift+R) or clear browser cache');
      console.error('Error details:', event.error);
    }
  });

  // Also listen for unhandled promise rejections (common with module loading issues)
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && typeof event.reason === 'string' && (
      event.reason.includes('Failed to fetch') ||
      event.reason.includes('Loading chunk')
    )) {
      console.error('🚨 Unhandled promise rejection (possibly module loading):', event.reason);
      console.error('💡 Try: Hard refresh (Cmd+Shift+R / Ctrl+Shift+R) or clear browser cache');
    }
  });
}

createRoot(document.getElementById("root")!).render(<App />);
